import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from 'Redux/store';
import App from './App';
import * as setup from 'setup';
import * as serviceWorker from './serviceWorker';
import 'teko-oauth2';
import 'index.css';

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root'),
);

setup.run();
serviceWorker.unregister();
